export function computeOneCaiFee ({ prepareModel }) {
  if (!prepareModel) return 0
  return prepareModel.parcelsInfo.jyHctCaiPPU
}

export function computeChargeHctHatPalletCai () {
  return 13
}

export function computeChargeHctHatPalletWeight () {
  return 70000
}

export function computeChargeHctFeeCai ({ jyAddrid }) {
  if (jyAddrid === '1598' || jyAddrid === '1210') return 4
  return 6
}

export function computeHasFurniture ({ parcels }) {
  return parcels.find(parcel => parcel.isFurniture)
}

export function computeHasHctHatPalletFeeParcels ({ parcels }) {
  return parcels
    ?.filter(parcel => !parcel.extraInfo.whseSuspendAt)
    ?.filter(parcel => parcel.hctCai > 10 || parcel.weight >= 70000)
}

export function computeHasHctCaiFeeParcels ({
  parcels,
  hasHctHatPalletFeeParcels,
  isBizParcel,
  hasFurniture,
}) {
  return parcels
    ?.filter(parcel => !parcel.extraInfo.whseSuspendAt)
    ?.filter(parcel => {
      if (parcel.jyAddrid === '1598' || parcel.jyAddrid === '1210') {
        return parcel.hctCai > 5
      }
      return parcel.hctCai > 6
    })
    ?.filter(parcel => {
      if (hasHctHatPalletFeeParcels.find(item => item.pclid === parcel.pclid)) return false
      if (isBizParcel) return true
      if (parcel.jyAddrid === '1598' || parcel.jyAddrid === '1210') return true
      return hasFurniture
    })
}

export function computeOneHctPalletFee ({ addrInfo, hctCitiesPalletFee }) {
  if (!addrInfo) return 1000
  let fee = 0
  Object.keys(hctCitiesPalletFee).forEach((key) => {
    if (addrInfo.city.indexOf(key) > -1) fee = Number(hctCitiesPalletFee[key])
  })
  return fee
}

export function computeHasJyHctCaiFee ({ finalUseFirstCarrier, jyHctCaiFee }) {
  return finalUseFirstCarrier === 'hct' && jyHctCaiFee > 0
}

export function computeJyHctCai ({ hasHctCaiFeeParcels, chargeHctFeeCai }) {
  return hasHctCaiFeeParcels.reduce((acc, parcel) => {
    return parcel.hctCai - chargeHctFeeCai + acc
  }, 0)
}

export function computeJyHctCaiFeeData ({
  showJybCoinFeatures,
  userKnapsackHctCaiFee,
  jyHctCai,
}) {
  const result = {
    fee: 0,
    useKnsCount: 0,
  }
  if (!showJybCoinFeatures) return result
  if (userKnapsackHctCaiFee && userKnapsackHctCaiFee.ksugBalance > 0) {
    result.useKnsCount = Math.min(userKnapsackHctCaiFee.ksugBalance, jyHctCai)
  }
  return result
}

export function computeJyHctCaiFee ({
  srLabel,
  finalUseFirstCarrier,
  jyHctCai,
  useKnsCount,
  oneCaiFee,
}) {
  if (srLabel !== 'HZKZQ' && finalUseFirstCarrier === 'hct') {
    return (jyHctCai - useKnsCount) * oneCaiFee
  }
  return 0
}

export function computePreHctPalletFee ({ oneHctPalletFee, palletCount, useKnsCount }) {
  return oneHctPalletFee * (palletCount - useKnsCount)
}

export function computeHctPalletFeeData ({
  showJybCoinFeatures,
  userKnapsackHctPalletFee,
  palletCount,
}) {
  const result = {
    fee: 0,
    useKnsCount: 0,
  }
  if (!showJybCoinFeatures) return result
  if (userKnapsackHctPalletFee && userKnapsackHctPalletFee.ksugBalance > 0) {
    result.useKnsCount = Math.min(userKnapsackHctPalletFee.ksugBalance, palletCount)
  }
  return result
}

export function computeHctPalletFee ({ srLabel, finalUseFirstCarrier, preHctPalletFee }) {
  if (srLabel !== 'HZKZQ' && finalUseFirstCarrier === 'hct') return preHctPalletFee
  return 0
}

export function computePreJyoOvldFee ({ weightLight, onlyShpMethod91ByVolumeLimit }) {
  if (weightLight || onlyShpMethod91ByVolumeLimit) return 2700
  return 0
}
